import { includes } from 'lodash';
import mapEditorSectionToUrl from 'config/mapEditorSectionToUrl';

const isSectionLegit = sectionName =>
  includes(mapEditorSectionToUrl, sectionName);

export default isSectionLegit;
